export default {"src":"/_next/static/media/bscscan.a50e7cfb.svg","height":122,"width":122,"blurWidth":0,"blurHeight":0};